export default "__VITE_ASSET__BMA8ALT1__"